module.exports = __webpack_public_path__ + "assets/img/ee45-al.svg";